let Variables = {
    base_url:"",
    api_url:"",
};

if(process.env.NODE_ENV==='development'){
    Variables.base_url=process.env.REACT_APP_DEVELOPMENT_URL
    Variables.api_url=process.env.REACT_APP_CM_API_DEVELOPMENT
}else if(process.env.NODE_ENV==='production'){
    Variables.base_url=process.env.REACT_APP_PRODUCTION_URL
    Variables.api_url=process.env.REACT_APP_CM_API_PRODUCTION
}

export default Variables